import { parseFontValue } from '../parser';

export const textDecomposeMap = {
  font: (value: string) => {
    const font = parseFontValue(value);

    return Object.fromEntries<string | null>(
      Object.entries(font) as [string, string | null][],
    );
  },
};
